import React, { useState, useEffect } from 'react';
import { EditButton } from 'shared/Buttons/EditButton/EditButton';
import { OkButton } from 'shared/Buttons/OkButton/OkButton';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 100%;          /* ensures textarea knows its boundary */
  align-items: flex-start;
  align-items: center;   /* centers vertically */
  justify-content: align-start;
  gap: 8px;
`;

const Label = styled.div`
  font-size: 16px;
  cursor: pointer;
  white-space: pre-wrap; /* preserve line breaks */
`;

const EmptyLabel = styled.div`
  font-size: 16px;
  cursor: pointer;
  color: #999; // light gray text    
  white-space: pre-wrap; /* preserve line breaks */
`;

const TextArea = styled.textarea`
  width: 330px;
  min-height: 35px;
  box-sizing: border-box;
  font-size: 16px;
  padding: 6px 8px;
  resize: vertical;
`;

interface EditableMultilineTextProps {
    initialText?: string;
    textPlaceholder?: string;
    onChange?: (value: string) => void;
}

export const EditableMultilineText: React.FC<EditableMultilineTextProps> = ({
  initialText = "",
  textPlaceholder = "Empty",
  onChange,
}) => {
    const [text, setText] = useState(initialText);
    const [isEditing, setIsEditing] = useState(false);

    function endEditing()  {
        setIsEditing(false);
        onChange?.(text);
    }

    const handleChangeDescription = () => {
        if (isEditing){
            endEditing();
        }
        else{
            setIsEditing(true)
        }
    };

    return (
    <Container>
        {isEditing ? (
            <TextArea
                value={text}
                autoFocus
                placeholder={textPlaceholder}
                onChange={(e) => setText(e.target.value)}
                onBlur={() => endEditing()}
            />
            ) : text?.trim() ? (
                <Label onClick={() => setIsEditing(true)}>{text}</Label>
            ) : (
                <EmptyLabel onClick={() => setIsEditing(true)}>
                    {`[${textPlaceholder}]`}
                </EmptyLabel>
            )}

            {isEditing ? (
                <OkButton onClick={handleChangeDescription} />
             ):(
                <EditButton onClick={handleChangeDescription} />
            )}
        </Container>
    );
};